module.exports = __webpack_public_path__ + "static/img/5133_phase_function_Paper_PointsHejduk_Prediction.ec6cc31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5133_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7anC
// module chunks = 0